import { render, staticRenderFns } from "./CreateSettingTaxAccountModal.vue?vue&type=template&id=6f97972a&scoped=true&"
import script from "./CreateSettingTaxAccountModal.vue?vue&type=script&lang=js&"
export * from "./CreateSettingTaxAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSettingTaxAccountModal.vue?vue&type=style&index=0&id=6f97972a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f97972a",
  null
  
)

export default component.exports